export default "__VITE_ASSET__Dq_VYiw2__"